import { formatNumber, formatPercent } from '@angular/common';
import { CmpsCardRowData, RowType, TrendType } from '@cmps/ng-kit';
import { TranslateService } from '@ngx-translate/core';

import { epicDependencies } from '../../store';
import { CoachingItemsOaScoreTypeTranslationMap } from '../constants/coaching-items-score-type-translation-map';
import { MyCoachingCardGroup } from '../models/my-coaching-card-group.model';
import { OaScoreType } from '../models/oa-score-type.enum';
import { TranslationKeyMap } from '../my-coaching-card.i18n';

export function getCardRowData(
    oaSummaryItem: MyCoachingCardGroup,
    isTypeFloa?: boolean,
): CmpsCardRowData {
    const translateService =
        epicDependencies.injector.get<TranslateService>(TranslateService);

    let dataRowNameLabel: string;
    let rowType: RowType;
    let isVisible: boolean;

    if (oaSummaryItem.type === OaScoreType.OA) {
        if (isTypeFloa === true) {
            dataRowNameLabel = translateService.instant(
                TranslationKeyMap._4005_FLOA__,
            );
            rowType = RowType.FLOA;
            isVisible = true;
        } else {
            dataRowNameLabel = translateService.instant(
                CoachingItemsOaScoreTypeTranslationMap[oaSummaryItem.type],
            );
            rowType = RowType.OA;
            isVisible = isTypeFloa === false;
        }
    } else {
        dataRowNameLabel = translateService.instant(
            CoachingItemsOaScoreTypeTranslationMap[oaSummaryItem.type],
        );
        rowType = RowType.OA_CHILD;
        isVisible =
            isTypeFloa === false &&
            (oaSummaryItem.type === OaScoreType.OA ||
                oaSummaryItem.type === OaScoreType.Super_Group_OA ||
                oaSummaryItem.type === OaScoreType.Site_OA);
    }

    const pctTgt = oaSummaryItem.score / oaSummaryItem.target;

    let trendColor;

    if (oaSummaryItem.trendId === TrendType.UP) {
        trendColor = '#4b8a08';
    } else if (oaSummaryItem.trendId === TrendType.DOWN) {
        trendColor = '#941000';
    } else {
        trendColor = '#000';
    }

    return {
        dataRowNameLabel,
        rowType,
        isVisible,
        percentageValue:
            oaSummaryItem.score != null
                ? formatPercent(oaSummaryItem.score, 'en-CA', '1.0-0')
                : '-',
        placeholderStr:
            oaSummaryItem.trendId !== TrendType.UNKNOWN
                ? null
                : translateService.instant(TranslationKeyMap._9402_NA),
        opportunityColor: oaSummaryItem.color,
        menuTooltipData: [
            {
                label: translateService.instant(TranslationKeyMap._725_ACTUAL),
                value:
                    oaSummaryItem.score != null
                        ? formatNumber(
                              oaSummaryItem.score * 100,
                              'en-CA',
                              '1.0-2',
                          )
                        : '-',
            },
            {
                label: translateService.instant(TranslationKeyMap._726_TARGET),
                value: formatNumber(
                    oaSummaryItem.target * 100,
                    'en-CA',
                    '1.0-2',
                ),
            },
            {
                label: translateService.instant(
                    TranslationKeyMap._768___TO_TARGET,
                ),
                value: formatPercent(pctTgt, 'en-CA', '1.0-2'),
            },
            {
                label: translateService.instant(
                    TranslationKeyMap._4105_PREVIOUS_ACTUAL,
                ),
                value:
                    oaSummaryItem.prevScore != null
                        ? formatNumber(
                              oaSummaryItem.prevScore * 100,
                              'en-CA',
                              '1.0-2',
                          )
                        : '-',
            },
        ],
        trendId: oaSummaryItem.trendId,
        trendColor,
    };
}
